export default "/images/de.svg?619108e6b82cf0941363a981f4446aa8";